import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IPromoCode } from 'src/app/api/modules/core/dynamic/components/IPromoCode';

/**
 * The PromoCodeComponent is used to display a styled text representation of a promo code.
 */
@Component({
  selector: 'app-promo-code',
  templateUrl: './promo-code.component.html',
  styleUrls: ['./promo-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.promo-code-disabled]': 'disabled()',
  },
})
export class PromoCodeComponent {
  /**
   * The Config as provided to the element.
   *
   * Nothing renders until a config with a non-empty `text` arrives.
   */
  readonly config = input<IPromoCode | null>();

  /**
   * Renders the box inert: muted colors, no pointer cursor, and no
   * one-click-selects-all — the code stays readable but no longer offers
   * itself for copying. A client-driven state (e.g. a code its owner marked
   * as used), not part of the server config.
   */
  readonly disabled = input(false);
}
